<div class="validation-side-bar-actions-container">
  @if (model) {
    <div class="buttons">
      <ng-casto-circle-btn
        [faIcon]="locked ? faLock : faPaperPlane"
        [loading]="buttonsLoading"
        [disabled]="buttonsLoading || locked"
        [color]="'yellow'"
        [label]="'validation.side-bar-actions.send-to-com-plus' | translate"
        (click)="sendToComPlus()"></ng-casto-circle-btn>

      @if (isPrevisitWorkbench) {
        <ng-casto-circle-btn
          [faIcon]="locked ? faLock : faCalendar"
          [loading]="buttonsLoading"
          [disabled]="buttonsLoading || locked || !featureSettingsService.poseEnabled"
          [color]="'yellow'"
          [label]="'validation.side-bar-actions.previsit_workbench' | translate"
          (click)="orderPrevisitWorkbench()"></ng-casto-circle-btn>
      }
      <ng-casto-circle-btn
        [faIcon]="locked ? faLock : faCalendar"
        [loading]="buttonsLoading"
        [disabled]="buttonsLoading || locked || !featureSettingsService.poseEnabled"
        [color]="'yellow'"
        [label]="'validation.side-bar-actions.previsit_' + context | translate"
        (click)="orderPrevisitConfiguration()"></ng-casto-circle-btn>

      <ng-casto-circle-btn
        [faIcon]="faPercentage"
        [loading]="printLoading || buttonsLoading"
        [disabled]="printLoading || buttonsLoading"
        [label]="'validation.side-bar-actions.discount' | translate"
        (click)="showDiscountChoice()"></ng-casto-circle-btn>

      <!--<ng-casto-circle-btn
                    [faIcon]="faEnvelope"
                    [loading]="printLoading || buttonsLoading"
                    [disabled]="printLoading || buttonsLoading"
                    label="Envoi mail"
                    (click)="sendMail()"
            ></ng-casto-circle-btn>-->
      <ng-casto-circle-btn
        [faIcon]="faPrint"
        [loading]="printLoading || buttonsLoading"
        [disabled]="printLoading || buttonsLoading || checkFidIsUndefined() || checkFundingIsUndefined()"
        [label]="'validation.side-bar-actions.print' | translate"
        (click)="printValidationNew()"></ng-casto-circle-btn>
      <ng-casto-circle-btn
        [faIcon]="faList"
        [loading]="buttonsLoading"
        [disabled]="buttonsLoading"
        [label]="'validation.side-bar-actions.product-list' | translate"
        (click)="showProductList()"></ng-casto-circle-btn>
      <ng-casto-circle-btn
        [faIcon]="locked ? faLock : faSave"
        [loading]="buttonsLoading"
        [disabled]="buttonsLoading || locked"
        [label]="'validation.side-bar-actions.save' | translate"
        (click)="save()"></ng-casto-circle-btn>
      @if (locked) {
        <ng-casto-circle-btn
          [faIcon]="faUnlock"
          [loading]="buttonsLoading"
          [disabled]="buttonsLoading"
          [color]="'yellow'"
          [label]="'validation.side-bar-actions.unlock' | translate"
          (click)="unlock()"></ng-casto-circle-btn>
      }
    </div>
  } @else {
    <div class="buttons skeleton">
      <p-skeleton shape="circle" size="50px" />
      <p-skeleton shape="circle" size="50px" />
      <p-skeleton shape="circle" size="50px" />
      <p-skeleton shape="circle" size="50px" />
      <p-skeleton shape="circle" size="50px" />
    </div>
  }
</div>
